export const DRAG_N_DROP = 'DRAG_N_DROP';
export const REVISION = 'REVISION';
export const DATE_CHANGE = 'DATE_CHANGE';
export const EMPTY_WEEKS = 'EMPTY_WEEKS';
export const MOVE_SYLLABUS = 'MOVE_SYLLABUS';
export const DELETE_PHASE = 'DELETE_PHASE';
export const SCHEDULE_TEST_SAMPLE_FILE_URL =
  'https://mypat-v2-prod.s3.us-west-2.amazonaws.com/webcontent/Schedule_Create.xlsx';
export const SCHEDULED_TEST_SAMPLE_MAIN = 
  'https://mypat-v2-prod.s3.us-west-2.amazonaws.com/webcontent/cms/Schedule+Create+Main.xlsx';
export const SCHEDULED_TEST_SAMPLE_MILESTONE = 
  'https://mypat-v2-prod.s3.us-west-2.amazonaws.com/webcontent/cms/Schedule+Create+Milestone.xlsx';
export const FAQ_SAMPLE_FILE_URL = 
'https://mypat-v2-prod.s3-us-west-2.amazonaws.com/webcontent/cms/FAQ_Sample.xlsx';
export const BULK_IMPORT_SAMPLE_FILE =
  'https://mypat-v2-prod.s3.us-west-2.amazonaws.com/DestinationCourses.xlsx';
export const BULK_ADD_CONTENT_IMPORT =
'https://mypat-v2-prod.s3.us-west-2.amazonaws.com/webcontent/cms/Select+Content.xlsx';
export const BULK_ADD_COURSE_IMPORT =
'https://mypat-v2-prod.s3.us-west-2.amazonaws.com/webcontent/cms/DestinationCourses.xlsx';

export const IMAGE_BASE_URL = '/assets/svg/myLibrary/';

export const COURSE_ICON_MAP: any = {
  standard: 'blueBook',
  testSeries: 'yellowBook',
  combo: 'redBook'
};

export const COURSES_TAB = {
  COURSES: 'Courses',
  COURSE_CHANGE_REQUEST: 'Course Change Request',
  BULK_IMPORT: 'Bulk Import'
};

export const COURSE_REQUEST_TABS = [
  'Awaiting Approval',
  'Accepted',
  'Rejected',
  'Closed'
];

export const PUBLISH_OPTIONS = {
  PUBLISH: 'Publish',
  ACCEPT_AND_PUBLISH: 'Accept & Publish',
  SUBMIT_REQUEST: 'Submit Request'
};

const COURSE_MANGEMENT_BASE_URL = '/course-Management';
export const TEST_SERIES_EDIT = `${COURSE_MANGEMENT_BASE_URL}/testSeries/edit/published`;
export const BULK_REPORT_DOWNLOAD_URL = `${COURSE_MANGEMENT_BASE_URL}/bulkOperationReport`;

export const COURSE_CHANGE = [
  'Added',
  'Removed',
  'Re-Ordered',
  'Other Changes',
  'Advance Settings',
  'Date Changes',
];

export const COURSE_CHANGE_CONFIRMATION = [
  'Re-Ordered',
  'Date Changes',
];

export const COURSE_CHANGE_TYPE = {
  DATE_CHANGE: 'date-change',
  REORDER: 'reorder',
}

export const VERSION_PROPERTY = {
  BATCHES: 'batchCode',
  CENTRE: 'centerName',
  NAME: 'name'
}

export const ENTITY_TYPE = {
  ADMIN: 'admin',
  COURSE: 'course',
  PHASE: 'phase',
  WEEK: 'week',
  CHAPTER: 'chapter',
  CONCEPT: 'concept',
  TEST: 'test',
  NOTES: 'studyNotes',
  FORMULA: 'formula',
  VIDEO: 'video',
  AUDIO: 'audio',
};

export const COURSE_VIEW_LIST = [
  {
    label: 'Plan Summary',
    key: ENTITY_TYPE.PHASE
  },
  {
    label: 'Week View',
    key: ENTITY_TYPE.WEEK
  },
  {
    label: 'Chapter View',
    key: ENTITY_TYPE.CHAPTER
  },
];

export const CHANGE_TYPE = {
  GLORIFIRE_PUBLISH: 'glorifirePublish',
  TEST_USER_PUBLISH: 'testUserPublish',
  COURSE_TYPE: 'courseType',
  COURSE_PRICE: 'coursePrice',
  LOCALE_WISE_PRICE: 'localeWisePrice',
  AVAILABLE_FOR_NCRP: 'availableForNCRP',
  AVAILABLE_FOR_CRP: 'availableForCRP',
  AVAILABLE_FOR_B2C: 'availableForB2C',
  DISCOUNT: 'discount',
  MAIN_TEST_INFO_ICON: 'mainTestInfoIcon',
  CONCEPT_TEST_INFO_ICON: 'conceptTestInfoIcon',
  FAQ_QUESTION: 'faqQuestion',
  FAQ_ANSWER: 'faqAnswer',
  META_TITLE: 'metaTitle',
  META_KEYWORD: 'metaKeyword',
  META_DESCRIPTION: 'metaDescription',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  NAME_CHANGE: 'name',
  DURATION_CHANGE: 'duration',
  PACKAGE_ADMIN: 'packageAdmin',
  ADMIN_NAME: 'adminName',
  IS_ACTIVE: 'isActive',
};

export const REQUEST_CHANGES = {
  ADD: 'add',
  REMOVE: 'remove',
  REORDER: 'reorder',
  OTHER: 'other',
  ADVANCE: 'advance',
  DATE_CHANGE: 'date-change',
};

export const PACKAGE_CHANGE_TYPE = {
  GENERAL_SETTING: 'generalSetting',
  FAQ: 'faq',
  SEO: 'seo',
  BASIC_INFO: 'basicInfo',
  COURSE_INFO: 'courseInfo',
};

export const CONTENT_LOCATION = {
  PHASE: 'Phase',
  WEEK: 'Week',
  SUBJECT: 'Subject',
  CHAPTER: 'Chapter',
  CONCEPT: 'Concept'
};

export const COURSE_BASE_IMAGE_URL = '/assets/svg/course-plan-request';

export const CHANGE_LABEL = {
  START_DATE: {
    LABEL: 'Start Date',
    TEST_LABEL: 'Start Date & Time',
    ICON: `${COURSE_BASE_IMAGE_URL}/calendar-green-ic.svg`,
    CLOCK_ICON: `${COURSE_BASE_IMAGE_URL}/start-clock.svg`,
  },
  END_DATE: {
    LABEL: 'End Date',
    TEST_LABEL: 'End Date & Time',
    ICON: `${COURSE_BASE_IMAGE_URL}/calendar-red-ic.svg`,
    CLOCK_ICON: `${COURSE_BASE_IMAGE_URL}/end-clock.svg`,
  },
  DISABLED: {
    LABEL: 'Disabled',
    ICON: `${COURSE_BASE_IMAGE_URL}/disabled-ic.svg`
  },
  ENABLED: {
    LABEL: 'Enabled',
    ICON: `${COURSE_BASE_IMAGE_URL}/enabled-ic.svg`
  },
  PAID: {
    LABEL: 'Paid',
    ICON: `${COURSE_BASE_IMAGE_URL}/paid-ic.svg`
  },
  FREE: {
    LABEL: 'Free',
    ICON: `${COURSE_BASE_IMAGE_URL}/free-ic.svg`
  },
  YES: {
    LABEL: 'Yes',
    ICON: `${COURSE_BASE_IMAGE_URL}/outside-yes.svg`
  },
  NO: {
    LABEL: 'No',
    ICON: `${COURSE_BASE_IMAGE_URL}/outside-no.svg`
  },
  PERCENTAGE_INCREASE: {
    LABEL: '%',
    ICON: `${COURSE_BASE_IMAGE_URL}/discount-ic.svg`
  },
  PERCENTAGE_DECREASE: {
    LABEL: '%',
    ICON: `${COURSE_BASE_IMAGE_URL}/discount-dc.svg`
  },
  MAIN_INFO: {
    LABEL: 'Jee Main',
    ICON: `${COURSE_BASE_IMAGE_URL}/main-test-info-ic.svg`
  },
  CONCEPT_INFO: {
    LABEL: 'Concept',
    ICON: `${COURSE_BASE_IMAGE_URL}/concept-test-info-ic.svg`
  }
};

export const BUSINESS_TYPE = [
  {
    VALUE: 'availableForCRP',
    LABEL: 'CRP'
  },
  {
    VALUE: 'availableForNCRP',
    LABEL: 'NCRP'
  },
  {
    VALUE: 'availableForB2C',
    LABEL: 'B2C'
  }
];

export const FILTERS = {
  REQUEST_TYPE: 'requestStatus',
  SEARCH_QUERY: 'searchQuery',
  CENTER_IDS: 'centerIds',
  COURSE_TYPE: 'courseType'
};

export const REQUEST_PLACEHOLDER = {
  REJECTED: {
    PLACEHOLDER: 'Reject',
    LABEL: 'Rejection'
  },
  CLOSED: {
    PLACEHOLDER: 'Close',
    LABEL: 'Closed'
  },
  CRP: {
    VALUE: 'availableForCRP',
    LABEL: 'CRP'
  },
  NCRP: {
    VALUE: 'availableForNCRP',
    LABEL: 'NCRP'
  },
};

export const REQUEST_REMARK = {
  REJECTED: 'Rejection',
  CLOSED: 'Closing'
};

export const WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const DATE_PARAMS = {
  AM: 'AM',
  PM: 'PM',
  REQUIRED: 'required',
  TWELVE_HOURS: 12,
  PADDED_ZERO: '0',
  TEN: 10,
};

export const REQUEST_CHANGES_KEYS = ['reorderedChanges', 'dateChanges'];
export const CONTENT_TYPE = {
  TEST_PAPERS: 'testpapers'
};

export const HIDE_TEST_POPUP_INFO = "Enabling this option will hide the test from the student's course plan, otherwise, it will remain visible to them."

export const SELECT_ALL = {
  LABEL: 'Select All',
  VALUE: 'selectAll',
};

export const SHOW_CHECKBOX = 'addConceptOrChapter';
export const SEARCH_QUERY_LENGTH = 3;
